import React, { useMemo } from 'react';

import BaseSelector from './BaseSelector';

const AssetGroupSelector = ({ filter, ...props }) => {
  const { operator, name } = filter;

  const onChange = value => {
    props.onChange({
      value,
      operator,
      name,
    });
  };

  const config = useMemo(() => {
    return {
      name,
      url: 'asset-groups/?members=N',
      valueKey: 'id',
      labelKey: 'name',
    };
  }, [name]);

  return (
    <>
      <div>Facility Groups</div>
      <BaseSelector filter={filter} config={config} onChange={onChange} />
    </>
  );
};
export default AssetGroupSelector;
